import {
  ADMIN_MY_INFO_CHANGE_PD_PATH,
  LOGIN_PATH,
  MY_INFO_CHANGE_PD_PATH,
} from "../global-constants";

export enum UserRole {
  Doctor = "Doctor",
  SuperAdmin = "SuperAdmin",
  Patient = "Patient",
  Admin = "Admin",
  Guardian = "Guardian",
  Nurse = "Nurse",
}

export const BASIC_ROLES_BY_FAIL = UserRole.Doctor;

export function getRoleFromString(role: string): UserRole {
  switch (role) {
    case "Doctor":
      return UserRole.Doctor;
    case "SuperAdmin":
      return UserRole.SuperAdmin;
    case "Patient":
      return UserRole.Patient;
    case "Admin":
      return UserRole.Admin;
    case "Guardian":
      return UserRole.Guardian;
    case "Nurse":
      return UserRole.Nurse;
    default:
      throw new Error(`[getRoleFromString] :: Invalid role: ${role}`);
  }
}

/**
 * 역할별 접근 제한 경로 매핑
 */
export const ROLE_RESTRICTED_ROUTES = {
  [UserRole.SuperAdmin]: ["/home", "/app-account-setting"],
  [UserRole.Doctor]: ["/admin", "/app-account-setting"],
} as const;

/**
 * 경로에서 역할 추출하는 함수
 */
export function getRoleFromPath(pathname: string): UserRole | null {
  if (pathname.startsWith("/admin")) {
    return UserRole.SuperAdmin;
  } else if (pathname.startsWith("/home")) {
    return UserRole.Doctor;
  }
  return null;
}

/**
 * 사용자 역할이 해당 경로에 접근할 수 있는지 확인
 */
export function hasAccessToPath(userRole: UserRole, pathname: string): boolean {
  const requiredRole = getRoleFromPath(pathname);
  if (!requiredRole) return true; // 역할이 필요한 경로가 아니면 접근 허용

  return userRole === requiredRole;
}

export function getHomeHref(userRole: UserRole): string {
  if (userRole === UserRole.SuperAdmin || userRole === UserRole.Admin) {
    return "/admin/home";
  }
  return "/home";
}

export function getPasswordChangeHref(roleOrPath: UserRole | string | null | undefined): string {
  if (!roleOrPath) {
    return LOGIN_PATH;
  }

  let userRole: UserRole | null = null;

  // 문자열이 들어온 경우 역할 문자열 또는 경로로 판단
  if (typeof roleOrPath === "string") {
    // 경로로 들어온 경우
    if (roleOrPath.startsWith("/")) {
      userRole = getRoleFromPath(roleOrPath);
    } else {
      // 역할 문자열로 들어온 경우
      try {
        userRole = getRoleFromString(roleOrPath);
      } catch {
        userRole = null;
      }
    }
  }

  switch (userRole) {
    case UserRole.Admin:
    case UserRole.SuperAdmin:
      return ADMIN_MY_INFO_CHANGE_PD_PATH;
    case UserRole.Doctor:
      return MY_INFO_CHANGE_PD_PATH;
    default:
      return LOGIN_PATH;
  }
}
